import Modal from "shared/Modal";
import type { TouchView } from "../api/OutreachTouchesApi";
import { groupByRfp } from "../dueStages";
import TouchCard from "./TouchCard";

/** The touches that fall due in the next 3 days, grouped by RFP, read-only (nothing can be sent before its day). */
export default function ComingUpModal({ items, onClose, onChanged }: { items: TouchView[]; onClose: () => void; onChanged: () => void }) {
  return (
    <Modal size="lg" title="Coming up in the next 3 days" description={`${items.length} ${items.length === 1 ? "touch" : "touches"} not due yet`} onClick={onClose} closeButtonCLick={onClose}>
      <div className="space-y-5">
        {groupByRfp(items).map((sec) => (
          <section key={sec.opportunity_id} aria-label={sec.title} className="space-y-3">
            <h3 className="text-sm font-semibold text-foreground">{sec.title} <span className="text-xs font-normal text-muted-foreground">({sec.items.length})</span></h3>
            {sec.items.map((t) => <TouchCard key={t.id} touch={t} onChanged={onChanged} readOnly hideRfp />)}
          </section>
        ))}
      </div>
    </Modal>
  );
}
